import IPTextarea from './IPTextarea'

export default IPTextarea
